import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { IProposal, IProposalsResult } from 'interfaces/proposals/proposal';
import { AppThunk } from 'app/store/store';  
import {  author_views } from 'services/db-service';
import { steemCustomApi } from 'services/dsteem-service';
import { getUser, getUserCommunitiesList, getUserFollowersList, getUserFollowingList } from 'services/user-service';

type UserState = {
  userData: any,
  isLoading: boolean,
  error: string | null
}

const userInitialState: UserState = {
  userData: {},
  isLoading:true,
  error: null
}

function startLoading(state: UserState) {
  state.isLoading = true
  state.userData = {}
}

function loadingFailed(state: UserState, action: PayloadAction<string>) {
  state.isLoading = false
  state.error = action.payload
}

const userData = createSlice({
  name: 'userData',
  initialState: userInitialState,
  reducers: {
    getUserStart: startLoading, 
    getUserSuccess(state, { payload }: PayloadAction<any>) {
      const { userData } = payload;
      state.isLoading = false;
      state.error = null;
      state.userData = userData;
    },
    getUserFailure: loadingFailed,
  }
});

export const {
  getUserStart,
  getUserSuccess, 
  getUserFailure,
} = userData.actions;
export default userData.reducer; 
export const fetchUser = (
  username, loading = true
): AppThunk => async (dispatch) => {
  try {
    if (loading) {
      dispatch(getUserStart());
    } 
    let userData:any = [];
    let savingsRequests:any = [];
    let followers_count = {};
    let outgoing_delegations = {};
    let views_count = 0;
    let data = null;
    if (username) {
      try {
        userData = await getUser(username); 
        followers_count = await steemCustomApi("condenser_api.get_follow_count", [username]);  
        views_count = await author_views(username) || 0; 
      } catch (error) {
        console.log(error)
      }
      try {
        if (userData?.savings_withdraw_requests > 0) {
          savingsRequests = await steemCustomApi("condenser_api.get_savings_withdraw_from", [username]);  
        }
      } catch (error) {
        console.log("While getting savings requests", error);
        
      }
      try {
        let del = await steemCustomApi("database_api.find_vesting_delegations", {account:username}); 
        outgoing_delegations =  del?.delegations || {};
      } catch (error) {
        console.log("While getting delegations", error);
      }
      let following_list, followers_list, communities;
      try {
        following_list  = await getUserFollowingList(username);
        followers_list  = await getUserFollowersList(username);
        communities  = await getUserCommunitiesList(username);
      } catch (error) {
        console.log("while getting followers and communities", error);
        
      }
      data = {
        ...userData,
        followers_count,
        views_count,
        outgoing_delegations,
        following_list,
        followers_list,
        communities,
        savings_withdraw_requests_list:savingsRequests
      }
      console.log(data);
       
    } 
    
    dispatch(getUserSuccess({
      userData:data
    }));
  } catch (err) {
    dispatch(getUserFailure(err.toString()));
  }
};